export async function fetchRefreshToken() {
  const router = useRouter()
  const runtimeConfig = useRuntimeConfig()
  const route = useRoute()

  const data = await $fetch('/customer/refresh-token', {
    server: false,
    method: 'POST',
    credentials: 'include',
    baseURL: runtimeConfig.public.apiBaseURL,
    body: {
      client: runtimeConfig.public.client,
    },
    onResponseError() {
      router.push({
        path: usePagePath('login'),
        query: {
          ...(route.fullPath !== usePagePath('self-service') && {
            redirect: route.fullPath,
          }),
        },
      })
    },
  })

  return data
}
